extractFragmentContext